import React from "react"

const TestUser = () => {
  return <h1>User Only</h1>
}

export default TestUser
